import React from 'react';
import { useEffect } from 'react';


function ScrollDown() {

    useEffect(() => {
//if at the bottom of page, hide scroll down button
        window.addEventListener('scroll', function() {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
                document.querySelector('.scroll__wrapper').style.display = 'none';
            } else {
                document.querySelector('.scroll__wrapper').style.display = 'block';
            }
        });


    }, []);
    return (  
<div className="scroll__wrapper">
<div id="scroll-down">
  <span className="arrow-down">
  </span>
  {/* <span id="scroll-title">
    Scroll down
  </span> */}
</div>
</div>

    );
}

export default ScrollDown;